import React from "react"
import { Col, Input, Label, Row } from "reactstrap"
import DynamicFormViewOnly from "components/custom/DynamicForm/View/ViewOnly/DynamicFormViewOnly"

const OccApproachSectionViewOnly = ({
  alternative,
  scenario,
  sectionFormId,
  systemRetirementsLabel,
}) => {
  if (scenario?.approachTabFormID > 0) {
    return (
      <Row>
        <Col md="12">
          <DynamicFormViewOnly
            formId={scenario.approachTabFormID}
            itemId={alternative?.alternativeID}
            scenarioId={alternative?.scenarioID}
          />
        </Col>
      </Row>
    )
  } else
    return (
      <React.Fragment>
        {sectionFormId != 0 && (
          <>
            <Row>
              <Col md="12">
                <div className="divider"></div>
                <DynamicFormViewOnly
                  formId={sectionFormId}
                  itemId={alternative?.alternativeID}
                  scenarioId={alternative?.scenarioID}
                />
              </Col>
            </Row>
          </>
        )}
      </React.Fragment>
    )
}

export default OccApproachSectionViewOnly
